export default __webpack_public_path__ + "static/couverture-livre-84c51c22f39a3ec7f92960f3d7e2f551.jpg";